module.exports = __webpack_public_path__ + "img/logo-portalconsultas.d94ae8e0.png";